export const general: GeneralSetup = {
    canonicalUrl: 'https://kromatic.com/tools/portfolio-management-game',
    documentDescription:
        "Kromatic's Ants is an interactive portfolio management game that shows how corporate governance can help meet strategic goals of innovation and business agility.",
    documentTitle: 'Portfolio Management Game - Kromatic',
    favicon: '/favicon.png',
    faq: [
        {
            question: 'What is Portfolio Management a.k.a. ANTS?',
            answer:
                'Portfolio Management a.k.a. ANTS is an interactive portfolio management game that shows how to adapt to rapid changes in your industry by putting you in charge of your own ant colony.',
        },
        {
            question: 'What do you practice in the game?',
            answer:
                'You practice disciplined resource allocation in an environment where a business-as-usual strategy can lead to disaster.',
        },
        {
            question: 'How does the game connect to business strategy?',
            answer:
                'The game explores how to divide resources between your core business, adjacent threats, and new, potentially disruptive opportunities.',
        },
    ],
    portionMarking: null,
    siteName: 'Kromatic',
    socialDescription:
        'Explore Kromatic’s portfolio management game and simulation to practice resource allocation across core, adjacent, and disruptive opportunities.',
    socialImage: 'https://kromatic.com/tools/portfolio-management-game/assets/landing/background.png',
    socialImageAlt: 'Illustrated ant colony scene from Kromatic’s Portfolio Management game',
    socialTitle: 'Portfolio Management Game | Kromatic',
};
